import useAirbridgeDynamicLink from '@/shared/hooks/useAirbridgeDynamicLink';
import useDebounceWithLoading from '@/shared/hooks/useDebounceWithLoading';

export { useAirbridgeDynamicLink, useDebounceWithLoading };
